import React from 'react';

import './index.less';

import { TokenUsage } from '../../../../gamma-api';
import { getTranslateFunc } from '../../../utils/stringUtil';
import { formatTokenCount } from '../../ContextWindowIndicator/utils';
import IbTypography from '../../common/IbTypography';
import IbTooltip from '../../common/IbTooltip';

import { GENERATIONS_CLASS_NAME, MAIN_CLASS_NAME, TRANSLATION_GROUP_PREFIX, VALUE_CLASS_NAME } from './const';

export interface IUsageTokensProps {
  generations: TokenUsage;
}

const translate = getTranslateFunc(TRANSLATION_GROUP_PREFIX);

const UsageTokens: React.FC<IUsageTokensProps> = ({ generations }) => {
  const { total, input, output, cache, reasoning = 0 } = generations;
  const thousandsSuffix = translate('Thousands suffix');
  const formatUsage = (value: number) => formatTokenCount(value, thousandsSuffix);

  const items = [
    {
      label: translate('Input: Label'),
      value: translate('Input: Value', { tokens: formatUsage(input) }),
    },
    {
      label: translate('Output: Label'),
      value: translate('Output: Value', { tokens: formatUsage(output) }),
    },
    {
      label: translate('Cache: Label'),
      value: translate('Cache: Value', { tokens: formatUsage(cache) }),
    },
    {
      label: translate('Reasoning: Label'),
      value: translate('Reasoning: Value', { tokens: formatUsage(reasoning) }),
    },
  ];

  const grid = (
    <div className={MAIN_CLASS_NAME}>
      {items.map((item) => (
        <React.Fragment key={item.label}>
          <span>{item.label}</span>
          <span className={VALUE_CLASS_NAME}>{item.value}</span>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <IbTooltip title={grid}>
      <IbTypography.Paragraph disabled className={GENERATIONS_CLASS_NAME} type="descriptor">
        {translate('Total', { tokens: formatUsage(total) })}
      </IbTypography.Paragraph>
    </IbTooltip>
  );
};

export default UsageTokens;
